import { Box, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PageTitle = ({ title, theme, subTitle = 0, beta = false }) => {
  const { t } = useTranslation("common");
  const isMobile = useSelector((state) => state.isMobile);
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        color={theme.palette.mode === "dark" ? "primary" : "black"}
        sx={{ fontSize: isMobile ? "1.2rem" : "1.5rem", fontWeight: 600 }}
      >
        {title}
        {beta ? <sup> {t("common.beta")}</sup> : null}
      </Typography>
      {
        //if beta, display beta tag
      }

      {subTitle ? (
        <Typography
          variant="caption"
          component="p"
          color={theme.palette.mode === "dark" ? "primary" : "black"}
          sx={{ fontSize: isMobile ? "0.8rem" : "1rem", fontWeight: 400 }}
        >
          {subTitle}
        </Typography>
      ) : null}
    </Box>
  );
};

export default PageTitle;
